import { RootContext } from "@/contexts/rootContext";
import { USER_SEX } from "@/utils/enum";
import { useContext } from "react";

export const useUserGender = () => {
  const { state } = useContext(RootContext);
  return {
    isFemaleUser: state?.user?.sex === USER_SEX.female,
    isMaleUser: state?.user?.sex === USER_SEX.male
  };
};
